import React from 'react';
import useStyles from './StepByStep.styles';
import { get, last } from 'global/lib/lodash';
import clsx from 'clsx';
import { useScreen } from 'global/styles';
import sStyles from 'global/styles';
import { useSelector } from 'react-redux';
import { sortByOrderKey } from 'global/utils';
import useBodyOverflow from 'global/hooks/useBodyOverflow';
import { ImageList } from 'global/components/image';
import Ecs from 'global/components/ecs/ecs.component.jsx';
import Image from 'global/components/image';
import { getIcon } from '../../definitions';
import { Icon } from '@mui/material';
import { Media } from 'global/components/Media';

const StepByStep = (props) => {
  // const isMobile = isMobileScreenXS();
  const { data, printView } = props;
  const Styles = sStyles();
  const classes = useStyles();
  // const placeimage = 'https://via.placeholder.com/350x550';
  const items = get(data, 'items', []).sort(sortByOrderKey);
  const view = useSelector((state) => get(state, 'view'));

  const { isUp } = useScreen();

  const showLogo = get(props, 'showLogo', false);

  useBodyOverflow({ hidden: isUp });

  const additionalText = get(props, 'additionalText');
  const subText = get(props, 'subText');

  const longTitle = items.filter((cp) => cp.name.length > 2).length > 0;

  const is3d = get(data, '3DAssets');

  const renderTitle = (cp) => {
    return (
      <strong className={clsx(classes.title, !longTitle && classes.capitalize)}>
        {cp.name}
        {!longTitle && `.`}
      </strong>
    );
  };

  const getLocalHtmlLink = () => {
    const { dir } = is3d;
    const loc = last(dir.split('/'));
    const url = `/ecs/${loc}/${loc}.html`;
    return url;
  };

  const ecsData = () => {
    return { steps: items.map((item, i) => ({ stepno: i + 1, steptext: get(item, 'description', get(item, 'name', i + 1)) })) };
  };

  return (
    <div className={clsx(classes.container, props.className)}>
      <div className={!showLogo && Styles.printOnly}>
        <div className={Styles.printLogoContainer}>
          <Image style={{ height: 100 }} src={get(view, 'style.props.logo')} alt={'Builder Logo'} unsetWidth />
        </div>
        {additionalText && <div className={classes.additionalText}>{additionalText}</div>}
        <div className={classes.checklistName}>{get(data, 'name')}</div>
        {subText && <div className={classes.subText}>{subText}</div>}
      </div>

      {is3d && !printView && <Ecs url={getLocalHtmlLink()} data={ecsData()} />}

      <div className={printView ? undefined : classes.textContainer}>
        {items.map((cp, i) => {
          const desc = get(cp, 'description', '');
          const image = get(cp, 'images.0');
          const icon = <Icon>{getIcon('step_by_step')}</Icon>;
          const images = cp.images.map((c) => ({ ...c, icon, description: desc }));

          return (
            <div className={classes.buffer}>
              <p>{renderTitle(cp)}</p>
              {image && (
                <div className={clsx(classes.chkimg)}>
                  <Media sourceType={['fullUrl']} {...image} description={desc} icon={icon} />
                </div>
              )}

              <div className={clsx(image ? classes.contentContainer : classes.contentContainerNoImage)}>
                <div key={cp.id} className={clsx(classes.row, classes.centerVertically)}>
                  <div className={classes.rowText}>
                    <span dangerouslySetInnerHTML={{ __html: desc }} />
                  </div>
                </div>
                {cp.images && (
                  <div className={classes.row}>
                    <ImageList spaceBetween={3} images={images} />
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StepByStep;
